import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=23e61c50&scoped=true&"
import script from "./AlertError.vue?vue&type=script&lang=js&"
export * from "./AlertError.vue?vue&type=script&lang=js&"
import style0 from "./AlertError.vue?vue&type=style&index=0&id=23e61c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e61c50",
  null
  
)

export default component.exports